<template>
  <div class="page">
    <full-page :options="options">
      <div class="section" data-anchor="top">
        <div class="block intro-block">
          <div class="content">
            <h1 class="header">#ОтФУДбольизжогу</h1>
            <p>Хочешь узнать, кто ты по ФУДбольной национальности?
              Тогда ты пришёл <span style="display: inline-block">по адресу!</span> Посмотри видео, пройди
              тест и прими участие в конкурсе!
              #отФУДбольизжогу вместе с Гевискон<sup>®</sup> и получи шанс выиграть гастротур в Бразилию!
            </p>
            <div class="arrow up-down"></div>

          </div>
        </div>
      </div>
      <div class="section" data-anchor="video">
        <video-section></video-section>
      </div>
      <div class="section" data-anchor="contest">
        <div class="block contest">
          <div class="content">
            <h1 class="title">Конкурс</h1>
            <div class="counter">
              <span class="number">1</span>
              <div class="c_line"></div>
              <span class="number">3</span>
            </div>
            <div class="ellipse">
              <div class="icon-picture"></div>
              <div class="line-1">Выложи фото в социальных сетях Вконтакте и Instagram с хэштегами</div>
              <div class="line-2">#ОтФУДбольизжогу <br>
                и #гевискон
              </div>
              <a href="/static/rules.pdf" target="_blank"class="link">Полные правила</a>
            </div>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="contest2">
        <div class="block contest contest-2">
          <div class="content">
            <h1 class="title">Конкурс</h1>
            <div class="counter">
              <span class="number">2</span>
              <div class="c_line"></div>
              <span class="number">3</span>
            </div>
            <div class="ellipse2">
              <div class="icon-pizza"></div>
              <div class="line">На которой ты болеешь
                за любимую команду на все 100%
                и наслаждаешься любимой едой
              </div>
            </div>
            <a href="/static/rules.pdf" target="_blank"class="link">Полные правила</a>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="contest3">
        <div class="block contest contest-3" v-if="this.$mq !== 'mobile'">
          <div class="content">
            <h1 class="title">Конкурс</h1>
            <div class="counter">
              <span class="number">3</span>
              <div class="c_line"></div>
              <span class="number">3</span>
            </div>
            <div class="ellipse">
              <div class="line">Самые креативные и крутые работы
                получат от нас призы
              </div>
              <div class="row">
                <div class="item">
                  <div class="icon-doc"></div>
                  <div class="text">Подарочный сертификат на покупку спортивных товаров
                  </div>
                </div>
                <div class="item">
                  <div class="icon-phone"></div>
                  <div class="text">
                    Смартфон Х
                  </div>
                </div>
                <div class="item">
                  <div class="icon-plane"></div>
                  <div class="text">
                    Гастротур на двоих
                    в Бразилию
                  </div>
                </div>
              </div>
              <a href="/static/rules.pdf" target="_blank"class="link">Полные правила</a>
            </div>
            <router-link to="/gallery" class="button">Смотреть галерею</router-link>
          </div>
        </div>
        <div class="block contest" v-if="this.$mq === 'mobile'">
          <div class="content" style="width: 100%; max-width: 100vmin;">
            <h1 class="title">Конкурс</h1>
            <div class="counter">
              <span class="number">3</span>
              <div class="c_line"></div>
              <span class="number">3</span>
            </div>
            <div class="ellipse" style="padding-bottom: 2vmin;margin-bottom: 5vmin;">
              <div class="line">Самые креативные и крутые работы
                получат от нас призы
              </div>
              <swiper ref="mySwiper" :options="swiperOption">
                <swiper-slide>
                  <div class="slide-item">
                    <div class="icon-doc"></div>
                    <div class="text">Подарочный сертификат на покупку спортивных товаров
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="slide-item">
                    <div class="icon-phone"></div>
                    <div class="text">
                      Смартфон Х
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="slide-item">
                    <div class="icon-plane"></div>
                    <div class="text">
                      Гастротур на двоих
                      в Бразилию
                    </div>
                  </div>
                </swiper-slide>

                <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
              </swiper>

            </div>
            <router-link to="/gallery" class="button">Смотреть галерею</router-link>
            <a href="/static/rules.pdf" target="_blank"class="link">Полные правила</a>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="test">
        <div class="block test">
          <div class="content">
            <h1 class="header">Кто вы по ФУДбольной
              национальности?</h1>
            <p class="text">
              Пройдите тест и узнайте, в какой стране вы точно сошли бы за своего во время просмотра матча.
            </p>
            <router-link to="/test" class="button">Пройти тест</router-link>

          </div>
        </div>
      </div>
      <div class="section" data-anchor="about">
        <product></product>
      </div>
      <curtains-index></curtains-index>
    </full-page>
    <div>
      <fixed-blocks v-if="this.$mq !== 'mobile'">
        <index-navigation></index-navigation>
      </fixed-blocks>
      <fixed-blocks-mobile v-if="this.$mq === 'mobile'">
        <index-navigation></index-navigation>
      </fixed-blocks-mobile>
    </div>
  </div>
</template>

<script>
    import FullPage from 'vue-fullpage.js';
    import fixedBlocks from '../components/common/fixedBlocks';
    import fixedBlocksMobile from '../components/common/fixedBlocksMobile';
    import CurtainsIndex from '../components/common/CurtainsIndex';
    import IndexNavigation from '../components/IndexNavigation';
    import VideoSection from '../components/Video'
    import Product from '../components/ProductSection'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'


    export default {
        name: "Index",
        metaInfo: {
            title: '#отфудбольизжогу',
            titleTemplate: null
        },
        data() {
            return {
                options: {
                    scrollBar: false,
                    menu: '.navigation',
                    slidesVideo: ['video']
                },
                swiperOption: {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination'
                    }
                },
            }
        },
        components: {
            FullPage,
            fixedBlocks,
            fixedBlocksMobile,
            CurtainsIndex,
            IndexNavigation,
            VideoSection,
            Product,
            swiper,
            swiperSlide
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        methods:{
            sendGaLink(title) {
                this.$ga.event('Ссылка', 'Переход по ссылке "' + title + '"', 1);
            }
        },
        beforeDestroy() {
            $.fn.fullpage.destroy('all');
        }
    }
</script>

<style scoped lang="scss">
  @import '~swiper/dist/css/swiper.css';

  .block {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    &.intro-block {
      background-image: url("../assets/images/blocks/intro_bg.jpg");
      .content {
        width: 70%;
        max-width: 600px;
        overflow: hidden;
        padding-bottom: 50px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .arrow {
          margin-top: 50px;
          z-index: 1;
        }
      }
      .header {
        font-size: 60px;
        font-weight: 700;
        line-height: 1.2;
        text-align: center;

      }
      p {
        line-height: 1.4;
      }
    }
    &.contest {
      background-image: url("../assets/images/blocks/contest_bg.jpg");
      &.contest-2 {
        background-image: url("../assets/images/blocks/contest2_bg.jpg");
        .link {
          bottom: 35px;
        }
      }
      &.contest-3 {
        background-image: url("../assets/images/blocks/contest3_bg.jpg");
        .link {
          display: unset;
          position: static;
        }
        .line {
          margin-top: 0px;
          width: 80%;
        }
        .ellipse {
          background-position: top center;
          background-size: 50% 85%;
          padding-top: 15px;
          min-width: 365px;
          min-height: 331px;
        }
      }
      .text {
        font-size: 11px;
      }
      .content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        max-width: 660px;
        min-height: 476px;
        z-index: 2;
      }
      .ellipse {
        padding-top: 25px;
        min-width: 365px;
        min-height: 344px;
        position: relative;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='365px' height='333px'%3e%3cdefs%3e%3clinearGradient id='PSgrad_0' x1='0%25' x2='39.073%25' y1='92.05%25' y2='0%25'%3e%3cstop offset='0%25' stop-color='rgb(81,37,99)' stop-opacity='1' /%3e%3cstop offset='100%25' stop-color='rgb(255,64,114)' stop-opacity='1' /%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill-rule='evenodd' fill='rgb(0, 0, 0)' d='M158.274,1.227 C253.770,15.146 365.000,64.765 365.000,161.378 C365.000,257.990 275.030,311.380 203.803,328.919 C111.761,351.585 145.988,275.234 33.993,202.031 C-51.646,146.055 43.475,-15.505 158.274,1.227 Z'/%3e%3cpath fill='url(%23PSgrad_0)' d='M158.274,1.227 C253.770,15.146 365.000,64.765 365.000,161.378 C365.000,257.990 275.030,311.380 203.803,328.919 C111.761,351.585 145.988,275.234 33.993,202.031 C-51.646,146.055 43.475,-15.505 158.274,1.227 Z'/%3e%3c/svg%3e");
        background-position: bottom center;
        background-repeat: no-repeat;
      }
      .ellipse2 {
        padding-top: 25px;
        min-width: 346px;
        min-height: 333px;
        position: relative;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='346px' height='333px'%3e%3cdefs%3e%3clinearGradient id='PSgrad_0' x1='0%25' x2='39.073%25' y1='92.05%25' y2='0%25'%3e%3cstop offset='0%25' stop-color='rgb(81,37,99)' stop-opacity='1' /%3e%3cstop offset='100%25' stop-color='rgb(255,64,114)' stop-opacity='1' /%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill-rule='evenodd' fill='rgb(0, 0, 0)' d='M123.360,0.866 C196.888,-9.441 120.758,76.782 292.098,132.903 C378.626,161.245 361.147,337.030 226.019,332.120 C136.647,328.872 30.619,302.625 7.691,210.559 C-15.620,116.955 14.966,16.059 123.360,0.866 Z'/%3e%3cpath fill='url(%23PSgrad_0)' d='M123.360,0.866 C196.888,-9.441 120.758,76.782 292.098,132.903 C378.626,161.245 361.147,337.030 226.019,332.120 C136.647,328.872 30.619,302.625 7.691,210.559 C-15.620,116.955 14.966,16.059 123.360,0.866 Z'/%3e%3c/svg%3e");
        background-position: bottom center;
        background-repeat: no-repeat;
      }
      .title {
        font-size: 45px;
        font-weight: 700;
        line-height: 51px;
        text-align: center;
        margin: 0;
      }
      .line-1 {
        font-size: 30px; /* Приближение из-за подстановки шрифтов */
        font-weight: 300;
        line-height: 40px; /* Приближение из-за подстановки шрифтов */
        text-align: center;
        margin-top: 31px;
      }
      .line-2 {
        font-size: 35px; /* Приближение из-за подстановки шрифтов */
        font-weight: 700;
        line-height: 45px; /* Приближение из-за подстановки шрифтов */
        text-align: center;
      }
      .line {
        font-size: 30px;
        font-weight: 300;
        line-height: 40px;
        text-align: center;
        margin-top: 31px;
        margin: 0 auto;
        margin-top: 28px;
        width: 75%;
      }

      .row {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        max-width: 550px;
        margin: 0 auto;
        margin-top: 25px;
      }
      .item {
        width: 140px;
      }

      .icon-doc {
        background-image: url("../assets/icons/ico__doc.svg");
        width: 136px;
        height: 111px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: top center;
        margin: 0 auto;
      }
      .icon-phone {
        background-image: url("../assets/icons/ico__phone.svg");
        background-repeat: no-repeat;
        margin: 0 auto;
        width: 67px;
        height: 111px;
        background-position: top center;
        background-size: contain;

      }
      .icon-plane {
        background-image: url("../assets/icons/ico__plane.svg");
        background-repeat: no-repeat;
        margin: 0 auto;
        width: 111px;
        height: 111px;
        background-position: top center;
        background-size: contain;

      }
      .icon-picture {
        width: 107px;
        height: 111px;
        background-image: url("../assets/icons/ico__img.svg");
        background-repeat: no-repeat;
        background-size: cover;
        transform: rotate(-8.32deg);
        margin: 0 auto;
      }
      .icon-pizza {
        width: 142px;
        height: 142px;
        background-image: url("../assets/icons/ico__pizza.svg");
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 auto;
      }
      .text {
        font-size: 16px; /* Приближение из-за подстановки шрифтов */
        font-weight: 300;
        line-height: 20px; /* Приближение из-за подстановки шрифтов */
        text-align: center;
      }

      .link {
        font-size: 12px; /* Приближение из-за подстановки шрифтов */
        font-weight: 300;
        line-height: 20px; /* Приближение из-за подстановки шрифтов */
        text-decoration: underline;
        text-align: center;
        color: white;
        display: block;
        position: absolute;
        bottom: 22px;
        z-index: 4000;
        left: 50%;
        &:hover {
          text-decoration: none;
        }
        transform: translateX(-50%);

      }
    }
    &.test {
      background-image: url("../assets/images/blocks/test_bg.jpg");
      .content {
        width: 60%;
        max-width: 600px;
        overflow: hidden;
        margin: 0 auto;
        padding-bottom: 50px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;

        .header {
          font-size: 45px; /* Приближение из-за подстановки шрифтов */
          font-weight: 700;
          line-height: 55px; /* Приближение из-за подстановки шрифтов */
          text-align: center;
        }
        .text {
          font-size: 24px; /* Приближение из-за подстановки шрифтов */
          font-weight: 300;
          line-height: 32px; /* Приближение из-за подстановки шрифтов */
          text-align: center;
        }
        .button {
        }
      }
    }
  }

  .arrow {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='23.5px' height='13.5px'%3e%3cpath fill-rule='evenodd' stroke='rgb(255, 255, 255)' stroke-width='1px' stroke-linecap='butt' stroke-linejoin='miter' fill='none' d='M1.500,0.500 L11.500,10.500 L21.500,0.500 '/%3e%3c/svg%3e");
    margin: 0 auto;
    background-repeat: no-repeat;
    width: 23px;
    height: 13px;
    overflow: auto;
  }

  .counter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 180px;
    margin: 0 auto;
    margin-top: 21px;

    .c_line {
      display: block;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='92px' height='4px'%3e%3cpath fill-rule='evenodd' fill='rgb(255, 255, 255)' d='M2.434,-0.000 L89.553,-0.000 C90.658,-0.000 91.553,0.895 91.553,2.000 L91.553,2.000 C91.553,3.105 90.658,4.000 89.553,4.000 L2.434,4.000 C1.329,4.000 0.434,3.105 0.434,2.000 L0.434,2.000 C0.434,0.895 1.329,-0.000 2.434,-0.000 Z'/%3e%3c/svg%3e");
      width: 94px;
      height: 4px;
      background-repeat: no-repeat;
    }
    .number {
      font-size: 24px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
    }
  }

  @keyframes up-down {
    10%, 90% {
      transform: translateY(-2px);
    }

    20%, 80% {
      transform: translateY(2px);
    }

    30%, 50%, 70% {
      transform: translateY(-2px);
    }

    40%, 60% {
      transform: translateY(2px);
    }
  }

  .up-down {
    animation: up-down 6s linear infinite;
  }

  @media screen and (max-width: 768px) {

    .block {
      &.intro-block {
        background-image: url("../assets/images/blocks/intro_bg_mobile.jpg");
        .content {
          width: 90%;
          z-index: 300;
          .header {
            font-size: 30px;
            margin: 0;
            margin-top: 50px;
            line-height: normal;
          }
          p {
            font-size: 12px;
            line-height: 20px;
            max-width: 400px;
            margin: 0 auto;
          }
        }
      }

      &.contest {
        background-image: url("../assets/images/blocks/contest_bg_mobile.jpg");
        .content {
          min-height: 0;
          padding-bottom: 60px;
        }
        .title {
          font-size: 30px;
          line-height: 44px;
        }
        .line-1 {
          font-size: 18px;
          line-height: normal;
          margin-top: 10px;

        }
        .line-2 {
          font-size: 22px;
          line-height: normal;

        }
        .ellipse {
          min-width: 21vmin;
          min-height: 33vmin;
          background-position: center;
          padding-top: 0;
          padding-bottom: 10vmin;
          background-size: contain;
          .icon-picture {
            width: 60px;
            height: 60px;
          }
        }
        .ellipse2 {
          min-width: 21vmin;
          min-height: 33vmin;
          background-position: center;
          padding-top: 0;
          padding-bottom: 10vmin;
          background-size: contain;
          .icon-pizza {
            width: 60px;
            height: 60px;
          }

        }
        .line {
          font-size: 17px;
          line-height: 1.1;
          margin-top: 3vmin;
        }
        .link {
          bottom: 0
        }
        .icon-doc, .icon-phone, .icon-plane {
          width: 60px;
          height: 60px;
        }
        .slide-item {
          max-width: 80%;
          margin: 10px auto;
          padding-bottom: 4vh;
        }

      }
      &.contest-2 {

      }

      &.test {
        .content {
          .header {
            font-size: 25px;
            line-height: 1.1;
          }
          .text {
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
    }
    .counter {
      max-width: 121px;
      margin: 0 auto;
      .c_line {
        width: 60px;
        height: 4px;
        background: white;
        border-radius: 2px;
      }
      .number {
        font-size: 16px
      }
    }

    .silentbox-is-opened {
      .fullpage-wrapper {
        z-index: 2000;
      }
    }
    #silentbox-overlay{
      position: absolute;
    }

  }


</style>